import React from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { composeClassName } from '@/utils/util_helpers';
import { usePresentationContext } from '../../hooks/use-presentation-context';
import { useWindowDimensions } from '@/hooks/use-window-dimensions';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

const Presentation = () => {
  const { setNumPages, setPDFLoadingStatus, pageNumber, numPages } =
    usePresentationContext()!;
  const { screenIsSmallerThan } = useWindowDimensions();

  return (
    <div
      className={composeClassName(
        'relative mt-[4.8rem] mb-4 aspect-video w-full overflow-hidden rounded-lg border-[3px] border-solid border-E50 ',
        'md:mt-[5.6rem] md:mb-10',
        'lg:mb-[7.7rem]'
      )}
    >
      <Document
        file={require('@assets/coloc-teaser.pdf')}
        loading={null}
        className="w-full bg-white"
        onLoadError={(_) => setPDFLoadingStatus('failed')}
        onLoadSuccess={(pdf) => {
          setPDFLoadingStatus('loaded');
          setNumPages(pdf.numPages);
          pdf.saveDocument();
        }}
      >
        <Page
          pageNumber={pageNumber}
          loading={null}
          {...(screenIsSmallerThan('sm') && { width: 640, height: 360 })}
          className="[&>canvas]:!h-full [&>canvas]:!w-full"
        />
      </Document>
      <span className="absolute bottom-5 right-5 z-10 hidden text-lead2 text-text-secondary md:block">{`Slide ${pageNumber} of ${numPages}`}</span>
    </div>
  );
};

export { Presentation };
